import { useMutation } from '@tanstack/react-query';
import { supabase } from '@readsavor/supabase-client';
/**
 * Hook for resetting a user's password using Supabase native functionality.
 * The component calling this hook is responsible for handling side effects
 * like navigation or state updates in its `onSuccess` or `onError` callbacks.
 */
export const useResetPassword = () => {
    return useMutation({
        mutationFn: async ({ newPassword }) => {
            const { data, error } = await supabase.auth.updateUser({
                password: newPassword,
            });
            if (error) {
                throw error;
            }
            return data;
        },
        // Side effects (like clearing flags or navigation) are now handled
        // by the component that uses this hook, making this hook more reusable
        // and separating concerns.
    });
};
//# sourceMappingURL=useResetPassword.js.map